export default "__VITE_ASSET__DwIYlPTb__"